import { toTitleCase } from '../../../../../utils/text';

export const FIELD_IDS = {
  FOCUS_AREAS: '4VbTdvwhnXbJWflbnzbR',
  APPROACH: 'Bkz6IKYWZkWMbkvFsz5c',
  LANGUAGE: 'pW8Ln9ze5MK0ZZOHfAjF',
  STATUS: 'wUbhT4USQ5fj3yVJWjxt',
  AVAILABILITY: 'fi0ahkr9Xoh5EwownnRr',
  GENDER: '0k8vFOoyKtncwj78Fo0v',
};

export const MODALITY_MAPPING = {
  CBH: 'Certified Clinical Hypnotherapist',
  Parts: 'Parts',
  Regression: 'Regression',
};

const normalizeString = (str) => {
  if (!str) return '';
  return String(str).toLowerCase().trim();
};

const parseDelimitedString = (str) => {
  if (!str) return [];
  return normalizeString(str)
    .split('|')
    .map((item) => item.replace(/,$/, '').trim())
    .filter((item) => item);
};

const checkFieldMatch = (fieldValue, filterValue, filterKey) => {
  const isEmpty =
    filterValue === undefined ||
    filterValue === null ||
    filterValue === '' ||
    filterValue === 'All' ||
    (Array.isArray(filterValue) && filterValue.length === 0);
  if (isEmpty) return true;
  if (!fieldValue) return false;

  const filterValues = Array.isArray(filterValue) ? filterValue : [filterValue];
  const items = parseDelimitedString(fieldValue);

  return filterValues.some((fv) => {
    const mapped = filterKey === 'modality' ? MODALITY_MAPPING[fv] || fv : fv;
    const normalizedFilter = normalizeString(mapped);
    return items.some((item) => item.includes(normalizedFilter));
  });
};

const getFieldValue = (person, filterKey) => {
  const { customFields } = person.userData || {};

  switch (filterKey) {
    case 'focusArea':
      return (
        person.focusAreas || customFields?.find((f) => f.id === FIELD_IDS.FOCUS_AREAS)?.value || ''
      );
    case 'modality':
      return person.approach || customFields?.find((f) => f.id === FIELD_IDS.APPROACH)?.value || '';
    case 'language':
      return customFields?.find((f) => f.id === FIELD_IDS.LANGUAGE)?.value || '';
    case 'availability':
      return customFields?.find((f) => f.id === FIELD_IDS.AVAILABILITY)?.value || '';
    case 'gender':
      return customFields?.find((f) => f.id === FIELD_IDS.GENDER)?.value || '';
    default:
      return '';
  }
};

export const filterPractitioners = (people, filters) => {
  if (!people || people.length === 0) return [];

  return people.filter((person) => {
    if (person.status !== 'approved') return false;

    for (const [filterKey, filterValue] of Object.entries(filters)) {
      const isEmpty =
        !filterValue ||
        filterValue === 'All' ||
        (Array.isArray(filterValue) && filterValue.length === 0);
      if (isEmpty) continue;

      const fieldValue = getFieldValue(person, filterKey);

      if (!checkFieldMatch(fieldValue, filterValue, filterKey)) {
        return false;
      }
    }

    return true;
  });
};

export const getCustomFieldValue = (customFields, fieldId) => {
  const field = customFields?.find((field) => field.id === fieldId);
  return field?.value || '';
};

export const getFirst3Specialties = (specialtiesRaw) => {
  if (!specialtiesRaw) return '';

  if (typeof specialtiesRaw === 'string') {
    const specialtiesArray = specialtiesRaw
      .split(/[,|]/)
      .map((s) => s.trim())
      .filter((s) => s)
      .map(toTitleCase);
    return specialtiesArray.join(', ');
  }

  if (Array.isArray(specialtiesRaw)) {
    return specialtiesRaw.map(toTitleCase).join(', ');
  }

  return '';
};

export const mapGhlMemberToPerson = (member) => {
  const avatar = getCustomFieldValue(member.customFields, 'Uf5t1LoiYsc9z5teLXBr');
  const bio = getCustomFieldValue(member.customFields, '5TMXInKVCGOH7ebdmGWJ');
  const socialMedia = getCustomFieldValue(member.customFields, '9I1sftRRnWuBrMS8ShKT');
  const status = getCustomFieldValue(member.customFields, 'wUbhT4USQ5fj3yVJWjxt');
  const referralLink = getCustomFieldValue(member.customFields, '9I1sftRRnWuBrMS8ShKT');
  const fullName = member.name || `${member.firstName} ${member.lastName}`;
  const focusAreas = getCustomFieldValue(member.customFields, '4VbTdvwhnXbJWflbnzbR');
  const approach = getCustomFieldValue(member.customFields, 'Bkz6IKYWZkWMbkvFsz5c');

  return {
    id: member.id,
    name: fullName,
    title: 'Certified Hypnotherapist',
    img: avatar,
    status: (status || 'pending').toLowerCase(),
    location: member.country || 'US',
    email: member.email,
    website: member.website,
    socialMedia: socialMedia,
    focusAreas: focusAreas,
    approach: approach,
    fullBio: bio,
    referralLink: referralLink,
    tags: member.tags || [],
    userData: member,
    hourlyRate: member.hourlyRate,
    avatarPosition: member.avatarPosition || '', // object-position chosen in the dashboard
    links: {
      profile: `/practitioner-detail/${fullName.replace(/\s+/g, '-')}`,
      book: referralLink || `/booking?practitioner=${member.id}`,
    },
  };
};
